import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { SovosIconButton } from "mosaic-react";
import { SovosAIIcon } from "mosaic-react-platform";
import { useSoviAi } from "../../../contexts/SoviAiContext";
import { openSoviWithMessage, getSoviPrompt } from "../../../utils/soviChatUtils";

export default function AskSoviButton(props) {
    const { i18n } = useGlobalValue();
    const { hasAskSovi } = useSoviAi();
    const { value } = props || {};

    if (!hasAskSovi) return null;

    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        const identifier = value?.ruleId || value?.id;
        const message = getSoviPrompt("askSoviRule", { identifier });
        openSoviWithMessage(message);
    };

    return (
        <SovosIconButton tooltipText={i18n`sovi diagnose - understand your audit findings`} onClick={handleClick}>
            <SovosAIIcon />
        </SovosIconButton>
    );
}
